import React from 'react';
import VideoBackgroundComponent from './VideoBackground/VideoBackgroundComponent.jsx';
import SwitchLanguage from './switchLang/SwitchLanguage.jsx';
import { LanguageProvider } from './switchLang/useLang.jsx';
import HeroCharacter from './Hero/HeroRender.jsx';
import SubscribeWidget from './newsletterSub/SubscribeWidget.jsx';
import { KickstarterWidget } from './KikStart/KickstarterWidget.jsx';

const MainPage = () => {
    return (
        <> <LanguageProvider>
            <div style={{ display: 'flex' }}>
                <VideoBackgroundComponent />
                <SwitchLanguage />
                <HeroCharacter />
            </div>
        </LanguageProvider>
        </>
    );
}

export default MainPage;